export default "__VITE_ASSET__DW6hIrQu__"